export default "__VITE_ASSET__C$Ix4gyY__"